import React, { Suspense, useRef, useState } from "react"
import { Link } from "react-router-dom"
import * as THREE from 'three'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { Canvas } from "@react-three/fiber"
import { ContactShadows, Environment, useGLTF, OrbitControls, useAnimations } from "@react-three/drei"
import { proxy, useSnapshot } from "valtio"

const state = proxy({
    current: null,
})

function Model({ ...props }) {

    const group = useRef()
    const { nodes, materials } = useGLTF('/volcano/scene.gltf')
    const [hovered, set] = useState(null)
    console.log(hovered)
    return (
        <group ref={group} {...props} dispose={null}
            onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
            onPointerOut={(e) => e.intersections.length === 0 && set(null)}
            onPointerMissed={() => (state.current = null)}
            onPointerDown={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}
        >
            <group rotation={[-Math.PI / 2, 0, 0]}>
                <group rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[0.2, 0.01, 0.08]} rotation={[0, -1.33, 0]} scale={[0.13, 0.16, 0.17]}>
                        <mesh geometry={nodes.root_Material_343_0.geometry} material={materials.Material_343} />
                    </group>
                    <group position={[0.29, 0.01, 0.15]} scale={[-0.11, 0.16, 0.15]}>
                        <mesh geometry={nodes.root_Material_345_0.geometry} material={materials.Material_345} />
                    </group>
                    <group position={[0.27, 0.02, 0.09]} rotation={[0, 0.98, 0]} scale={[-0.13, 0.14, 0.15]}>
                        <mesh geometry={nodes.root_Material_347_0.geometry} material={materials.Material_347} />
                    </group>
                    <group position={[0.12, 0.01, 0.14]} scale={[0.2, 0.16, 0.16]}>
                        <mesh geometry={nodes.root_Material_349_0.geometry} material={materials.Material_349} />
                    </group>
                    <group position={[0.22, 0.02, 0.16]} rotation={[0, -0.3, 0]} scale={[0, 0, 0]}>
                        <mesh geometry={nodes.root_Material_351_0.geometry} material={materials.Material_351} />
                    </group>
                    <group position={[0.19, -0.09, 0.2]} rotation={[-0.11, 0.62, -0.21]} scale={[0.09, 0.18, 0.2]}>
                        <mesh geometry={nodes.root_Material_353_0.geometry} material={materials.Material_353} />
                    </group>
                    <group position={[0.25, 0.01, 0.23]} rotation={[0, -1.33, 0]} scale={[-0.15, 0.16, 0.17]}>
                        <mesh geometry={nodes.root_Material_355_0.geometry} material={materials.Material_355} />
                    </group>
                    <group position={[0.28, 0.02, 0.2]} rotation={[0, -0.72, 0]} scale={[-0.13, 0.14, 0.15]}>
                        <mesh geometry={nodes.root_Material_357_0.geometry} material={materials.Material_357} />
                    </group>
                    <group position={[0.03, -0.05, 0.09]} scale={[0.38, 0.02, 0.27]}>
                        <mesh geometry={nodes.root_Material_359_0.geometry} material={materials.Material_359} />
                    </group>
                    <group position={[0.02, -0.09, 0.1]} scale={[0, 0, 0.01]}>
                        <mesh geometry={nodes.root_Material_361_0.geometry} material={materials.Material_361} />
                    </group>
                    <group position={[0.01, -0.14, 0.1]} scale={[0, 0, 0.01]}>
                        <mesh geometry={nodes.root_Material_363_0.geometry} material={materials.Material_363} />
                    </group>
                    <group position={[0.28, -0.14, 0.2]} scale={[0, 0, 0.02]}>
                        <mesh geometry={nodes.root_Material_365_0.geometry} material={materials.Material_365} />
                    </group>
                    <group position={[0.28, -0.09, 0.19]} scale={[0, 0, 0.02]}>
                        <mesh geometry={nodes.root_Material_367_0.geometry} material={materials.Material_367} />
                    </group>
                    <group position={[0.28, -0.04, 0.18]} scale={[0.15, 0.02, 0.57]}>
                        <mesh geometry={nodes.root_Material_369_0.geometry} material={materials.Material_369} />
                    </group>
                    <group position={[0.06, -0.18, 0.21]} scale={[0, 0, 0.02]}>
                        <mesh geometry={nodes.root_Material_371_0.geometry} material={materials.Material_371} />
                    </group>
                    <group position={[0.04, -0.11, 0.18]} scale={[0.25, 0.06, 0.16]}>
                        <mesh geometry={nodes.root_Material_373_0.geometry} material={materials.Material_373} />
                    </group>
                    <group position={[0.1, -0.07, 0.19]} rotation={[0, 0, -Math.PI]} scale={[-0.16, 0.04, 0.11]}>
                        <mesh geometry={nodes.root_Material_373_0_1.geometry} material={materials.Material_373_0} />
                    </group>
                    <group position={[0.18, -0.11, 0.31]} rotation={[Math.PI, -1.33, 0]} scale={[0.16, 0.04, 0.1]}>
                        <mesh geometry={nodes.root_Material_373_0_2.geometry} material={materials.Material_373_1} />
                    </group>
                    <group position={[-0.1, -0.07, 0.12]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]} scale={[0.16, 0.15, 0.05]}>
                        <mesh geometry={nodes.root_Material_375_0.geometry} material={materials.Material_375} />
                    </group>
                    <group position={[-0.12, -0.04, 0.08]} rotation={[0, -1.04, 0]} scale={[0.03, 0.01, 0.04]}>
                        <mesh geometry={nodes.root_Material_377_0.geometry} material={materials.Material_377} />
                    </group>
                    <group position={[-0.12, -0.04, 0.11]} rotation={[0, 0.98, 0]} scale={[0.02, 0.01, 0.04]}>
                        <mesh geometry={nodes.root_Material_379_0.geometry} material={materials.Material_379} />
                    </group>
                    <group position={[-0.12, -0.04, 0.1]} scale={[0.03, 0.02, 0.05]}>
                        <mesh geometry={nodes.root_Material_381_0.geometry} material={materials.Material_381} />
                    </group>
                    <group position={[-0.1, -0.04, 0.1]} rotation={[-Math.PI, 0.72, -Math.PI]} scale={[0.02, 0.01, 0.05]}>
                        <mesh geometry={nodes.root_Material_383_0.geometry} material={materials.Material_383} />
                    </group>
                    <group position={[-0.1, -0.04, 0.09]} rotation={[-Math.PI, -0.98, -Math.PI]} scale={[0.02, 0.01, 0.04]}>
                        <mesh geometry={nodes.root_Material_314_0.geometry} material={materials.Material_314} />
                    </group>
                    <group position={[-0.1, -0.04, 0.09]} rotation={[-Math.PI, -0.98, -Math.PI]} scale={[0.02, 0.01, 0.04]}>
                        <mesh geometry={nodes.root_Material_385_0.geometry} material={materials.Material_385} />
                    </group>
                    <group position={[-0.02, -0.04, 0.07]} rotation={[-Math.PI, 0.5, -Math.PI]} scale={[0.03, 0.02, 0.05]}>
                        <mesh geometry={nodes.root_Material_387_0.geometry} material={materials.Material_387} />
                    </group>
                    <group position={[-0.04, -0.03, 0.04]} rotation={[-Math.PI, -1.52, -Math.PI]} scale={[0.03, 0.01, 0.05]}>
                        <mesh geometry={nodes.root_Material_379_0_1.geometry} material={materials.Material_379_0} />
                    </group>
                    <group position={[-0.03, -0.04, 0.05]} rotation={[-Math.PI, -0.54, -Math.PI]} scale={[0.04, 0.02, 0.06]}>
                        <mesh geometry={nodes.root_Material_389_0.geometry} material={materials.Material_389} />
                    </group>
                    <group position={[-0.06, -0.04, 0.06]} rotation={[0, -0.18, 0]} scale={[0.03, 0.02, 0.06]}>
                        <mesh geometry={nodes.root_Material_391_0.geometry} material={materials.Material_391} />
                    </group>
                    <group position={[-0.04, -0.04, 0.07]} rotation={[0, 1.52, 0]} scale={[0.03, 0.02, 0.05]}>
                        <mesh geometry={nodes.root_Material_314_0_1.geometry} material={materials.Material_314_0} />
                    </group>
                    <group position={[-0.04, -0.04, 0.07]} rotation={[0, 1.52, 0]} scale={[0.03, 0.02, 0.05]}>
                        <mesh geometry={nodes.root_Material_385_0_1.geometry} material={materials.Material_385_0} />
                    </group>
                </group>
            </group>
        </group>
    )
}

function Details() {

    const snap = useSnapshot(state)
    if (snap.current === "Material_353") {
        return (
            <div className="h-full md:flex md:flex-col md:justify-center">
                <h1 className="text-3xl uppercase">Magma chamber</h1>
                <p className="text-xl">A magma chamber is a large pool of liquid rock beneath the surface of the Earth. The molten rock, or magma, in such a chamber is less dense than the surrounding country rock, which produces buoyant forces on the magma that tend to drive it upwards.</p>
            </div>
        )
    }
    else if (snap.current === "Material_359") {
        return (
            <div className="h-full md:flex md:flex-col md:justify-center">
                <h1 className="text-3xl uppercase">Bedrock</h1>
                <p className="text-xl">Volcanic bedrock glade consists of an open forested or savanna community found where basaltic bedrock and conglomerates are exposed. The sparse vegetation consists of scattered open-grown trees, scattered shrubs or shrub thickets, and a partial turf of herbs, grasses, sedges, mosses, and lichens.</p>
            </div>
        )
    }
    else if (snap.current === "Material_347") {
        return (
            <div className="h-full md:flex md:flex-col md:justify-center">
                <h1 className="text-3xl uppercase">Conjugate</h1>
                <p className="text-xl">Condensed water vapor that falls to the Earth's surface. Most precipitation occurs as rain, but also includes snow, hail, fog drip, graupel, and sleet. Approximately 505,000 km3 (121,000 cu mi) of water falls as precipitation each year, 398,000 km3 (95,000 cu mi) of it over the oceans. The rain on land contains 107,000 km3 (26,000 cu mi) of water per year and a snowing only 1,000 km3 (240 cu mi). 78% of global precipitation occurs over the ocean.</p>
            </div>
        )
    }
    else if (snap.current === "Material_355") {
        return (
            <div className="h-full md:flex md:flex-col md:justify-center">
                <h1 className="text-3xl uppercase">Volcano</h1>
                <p className="text-xl">A volcano is a rupture in the crust of a planetary-mass object, such as Earth, that allows hot lava, volcanic ash, and gases to escape from a magma chamber below the surface.</p>
            </div>
        )
    }
    else {
        return (
            <div className="h-full md:flex md:flex-col md:justify-center">
                <h1 className="text-2xl tracking-wider">Click on diffrent parts of Water Cycle 3D model to know more</h1>
                <p className="self-center mx-8 text-xl tracking-wide text-justify">To view the 3D model in AR, scan the QR code or click on the button below.</p>

                <div className="grid justify-center grid-cols-1 gap-2 pb-8 mx-8 md:grid-cols-2 lg:grid-cols-2">
                    <img className="flex p-6 text-6xl rounded-xl h-48 w-48" src="https://storage.echo3d.co/morning-hill-2019/010502e2-a35e-46fe-a188-c6417b4678f6.png" alt="QR Code" />
                    <a href="https://go.echo3d.co/7w2r" target="_blank" rel="noreferrer">
                        <button className="h-12 px-8 ml-8 text-base font-semibold tracking-wider text-white border rounded-full shadow-sm mt-16 bg-red-50 bg-gradient-to-r from-purple-400 via-purple-500 to-pink-500  hover:shadow-lg">View in AR</button>
                    </a>
                </div>
            </div>
        )
    }
    // return (
    //     <div>
    //         {snap.current}
    //     </div>
    // )
}

export default function Volcano() {
    return (
        <>
            <div className="pt-8 text-white">

                <Link to="/explore" className="ml-8">Go Back</Link>

                <div className="grid w-full py-10 place-items-center">
                    <h1 className="pb-2 text-5xl font-semibold tracking-wide font-carattere lg:text-6xl">
                        Volcano
                    </h1>
                    <div className="inline-flex h-1 bg-indigo-500 rounded-full w-72"></div>
                    <div className="text-justify text-xl w-86 mt-2 mx-4 md:mx-44">A volcano is a rupture in the crust of a planetary-mass object, such as Earth, that allows hot lava, volcanic ash, and gases to escape from a magma chamber below the surface. On Earth, volcanoes are most often found where tectonic plates are diverging or converging, and most are found underwater. For example, a mid-ocean ridge, such as the Mid-Atlantic Ridge, has volcanoes caused by divergent tectonic plates whereas the Pacific Ring of Fire has volcanoes caused by convergent tectonic plates. </div>
                </div>

                <div className="md:grid md:grid-cols-3 md:pr-15 pr-1">

                    <div className="w-full h-screen px-4 outline-none cursor-pointer md:col-span-2 lg:block">
                        <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 4], fov: 50 }}>
                            <ambientLight intensity={0.7} />
                            <spotLight intensity={0.5} angle={0.1} penumbra={1} position={[10, 15, 10]} castShadow />
                            <Suspense fallback={null}>
                                <Model scale={6} />
                                <Environment preset="city" />
                                <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={1.5} far={0.8} />
                            </Suspense>
                            <OrbitControls autoRotate />
                        </Canvas>
                    </div>

                    <div className="mt-16 md:mt-0 md:col-span-1 p-4">
                        <Details />
                    </div>

                </div>

            </div>

        </>
    )
}
